/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ClusterService } from '../../modules/loadbalancer/shared/services/utilities';
import { Directive, HostListener, Input } from '@angular/core';
import { LogService } from '../services';
import { NodeModel } from '../../modules/loadbalancer/shared/models';

@Directive({ selector: '[appDownLoadFile]' })
export class DownloadFileDirective {
    /**
     * Content to be downloaded.
     */
    @Input() public content: any;

    /**
     * Function to be called instead of content.
     */
    @Input() public callBack: (...args: any[]) => void;

    /**
     * Filename including file type, if not set default.txt is used.
     */
    @Input() public fileName: string = 'default.txt';

    /**
     * Boolean input to include the hostname as a prefix for the filename
     */
    @Input() public prefixFileWithHostName: boolean = true;

    /**
     * Click event listener
     * @param event
     */
    @HostListener('click', ['$event'])
    public onClick(event: MouseEvent): void {
        // Stop any other actions on the element being clicked (e.g. submit form)
        event.preventDefault();

        if (this.callBack) {
            this.callBack();

            return;
        }

        // If local node info is available prefix the filename with the hostname.
        const localNode: NodeModel = this.clusterService.localNode;
        const fileName = this.prefixFileWithHostName && (localNode && localNode.hostname)
            ? localNode.hostname + '-' + this.fileName
            : this.fileName;

        // Create the file itself.
        const file = new Blob([this.content], { type: this.getContentType(this.fileName) });

        if (file && file.type.length) {
            const a = document.createElement('a');
            a.href = URL.createObjectURL(file);
            a.download = fileName;
            a.click();
        } else {
            this.logService.error('downloadFileDirective: @HostListener', 'Error Creating File');
        }

    }

    constructor(
        private logService: LogService,
        private clusterService: ClusterService
    ) {

    }

    /**
     * Get content type from filename
     * @param fileName
     */
    public getContentType(fileName: string): string {
        switch (fileName.split('.').pop()) {
            case 'txt':
                return 'text/plain';
            case 'json':
                return 'application/json';
            case 'xml':
                return 'application/xml';
            default:
                this.logService.error('downloadFileDirective:  getFileType', 'No file type match');
        }
    }
}
